import * as API from "@/services/API";
import { RecordIdentifier } from "@/data/global";
import { CourseProduct, Product } from "@/data/products";

interface OrderCreateParameter {
    gatewayId: RecordIdentifier,
    productId?: RecordIdentifier,
    courseId?: RecordIdentifier,
    steps?: Record<string, any>,
}

function orderCreate(params: OrderCreateParameter) {
    if( typeof params.productId === 'undefined' && typeof params.courseId === 'undefined' ) {
        console.error('orderCreate() expects productId or courseId, none given');
        return;
    }

    if( typeof params.productId !== 'undefined' && typeof params.courseId !== 'undefined' ) {
        console.error('orderCreate() expects only one out of productId or courseId');
        return;
    }

    return API.apiClient.post('/order/create', {
        ...params
    });
}

function orderCreateByProduct(gatewayId: RecordIdentifier, product: Product|CourseProduct, additionalOrderData?: Record<string, any>) {
    const params = { gatewayId } as OrderCreateParameter;
    if( product.type === 2 ) {
        params.courseId = (product as CourseProduct).course_id;
    }
    else {
        params.productId = (product as Product).id;
    }
    if( typeof additionalOrderData !== 'undefined' ) {
        params.steps = additionalOrderData;
    }
    return orderCreate(params);
}

export default {
    orderCreate,
    orderCreateByProduct,
    paymentCapture(gatewayId: number, gatewayReference: any) {
        return API.apiClient.post('/order/payment/capture', {
            gatewayId,
            gatewayReference
        });
    },
    paymentCancel(gatewayId: number, gatewayReference: any) {
        return API.apiClient.post('/order/payment/cancel', {
            gatewayId,
            gatewayReference
        });
    },
}
